import { useQuery } from "@tanstack/react-query";
import { PET_HEALTH_SUMMARY } from "../enums/QueryKeys";
import { fetchPetMedicalOverview } from "../enums/queryFunction/Fetch";

export function useGetPetMedicalOverview(petId) {
  const { data, isLoading, error } = useQuery({
    queryKey: [PET_HEALTH_SUMMARY, petId],
    queryFn: () => fetchPetMedicalOverview(petId),
    enabled: !!petId,
  });

  return { data, isLoading, error };
}
